import { ChronoCoreDensePanel, ChronoCoreRailPanel } from './chronoCore';
import { DigimonDensePanel, DigimonRailPanel } from './digimon';
import { GundamDensePanel, GundamRailPanel } from './gundam';
import { GrandArchiveDensePanel, GrandArchiveRailPanel } from './grandArchive';

// ---------------------------------------------------------------------------
// index — selectDensePanel / selectRailPanel registries: the single source of
// truth for the gameId → panel component mapping. Split out of the former
// DeckOverlayPanels.tsx monolith (pure move, no behavior change).
// ---------------------------------------------------------------------------

// ── D92: Panel selectors ──────────────────────────────────────────────────────

/**
 * Returns the dense compare panel component for a given gameId, or null if
 * no per-game dense panel exists (caller falls back to CuratedPlayerPanel).
 * This function is the SINGLE SOURCE OF TRUTH for the gameId → dense panel
 * mapping. Callers (DeckCompareOverlay) use it as a branch condition; rendering
 * with game-typed props still requires a switch on gameId in the caller.
 *
 * Return type is `React.ComponentType<any>` with justification: the returned
 * component is rendered by the caller with game-specific typed props — the
 * selector's role is routing, not uniform invocation.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function selectDensePanel(gameId: string): React.ComponentType<any> | null {
  switch (gameId) {
    case 'chrono-core': return ChronoCoreDensePanel as React.ComponentType<any>; // eslint-disable-line @typescript-eslint/no-explicit-any
    case 'digimon': return DigimonDensePanel as React.ComponentType<any>; // eslint-disable-line @typescript-eslint/no-explicit-any
    case 'gundam': return GundamDensePanel as React.ComponentType<any>; // eslint-disable-line @typescript-eslint/no-explicit-any
    case 'grand-archive': return GrandArchiveDensePanel as React.ComponentType<any>; // eslint-disable-line @typescript-eslint/no-explicit-any
    default: return null;
  }
}

/**
 * Returns the condensed rail panel component for a given gameId, or null if
 * no per-game rail panel exists (caller falls back to CuratedPlayerPanel).
 * Used exclusively by DeckProfileOverlay for the 25/75 split layout.
 * Do NOT use selectDensePanel in DeckProfileOverlay — dense and rail panels
 * have different width/height profiles and section sets.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function selectRailPanel(gameId: string): React.ComponentType<any> | null {
  switch (gameId) {
    case 'chrono-core': return ChronoCoreRailPanel as React.ComponentType<any>; // eslint-disable-line @typescript-eslint/no-explicit-any
    case 'digimon': return DigimonRailPanel as React.ComponentType<any>; // eslint-disable-line @typescript-eslint/no-explicit-any
    case 'gundam': return GundamRailPanel as React.ComponentType<any>; // eslint-disable-line @typescript-eslint/no-explicit-any
    case 'grand-archive': return GrandArchiveRailPanel as React.ComponentType<any>; // eslint-disable-line @typescript-eslint/no-explicit-any
    default: return null;
  }
}
